<div class="settings-wrapper" *ngIf="!loading">
    <div class="top-bar">
        <div class="left-section">
            <h2>Settings</h2>
            <p class="subtitle">Manage your account and preferences</p>
        </div>
        <div class="right-section">
            <button mat-icon-button aria-label="Notifications">
                <mat-icon matBadge="2" matBadgeColor="warn">notifications</mat-icon>
            </button>
            <div class="user-info">
                <div>
                    <div class="name">Admin User</div>
                    <div class="email">{{ adminEmail }}</div>
                </div>
                <div class="avatar">AD</div>
            </div>
        </div>
    </div>
    <div class="setting-management-container">
        <div class="card">
            <h3>Profile Settings</h3>
            <p class="desc">Update your personal information</p>

            <div class="form-row">
                <div class="form-group">
                    <label>Full Name</label>
                    <input type="text" [(ngModel)]="user.fullName" />
                </div>
                <div class="form-group">
                    <label>Email</label>
                    <input type="email" [(ngModel)]="user.email" />
                </div>
            </div>

            <div class="form-group">
                <label>Current Password</label>
                <input type="password" />
            </div>

            <div class="form-row">
                <div class="form-group">
                    <label>New Password</label>
                    <input type="password" />
                </div>
                <div class="form-group">
                    <label>Confirm Password</label>
                    <input type="password" />
                </div>
            </div>

            <button mat-flat-button color="primary" (click)="saveProfile()">Save Changes</button>
        </div>
        <div class="card">
            <h3>Institution Settings</h3>
            <p class="desc">Configure default settings for your institution</p>

            <div class="toggle-row">
                <div>
                    <h4>Auto Enrollment</h4>
                    <p>Automatically enroll students with institutional domain</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="settings.autoEnrollment"
                    (change)="toggleChange('autoEnrollment')">
                </mat-slide-toggle>
            </div>

            <div class="toggle-row">
                <div>
                    <h4>Email Verification</h4>
                    <p>Require email verification for new users</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="settings.emailVerification"
                    (change)="toggleChange('emailVerification')">
                </mat-slide-toggle>
            </div>

            <div class="toggle-row">
                <div>
                    <h4>AI Course Generation</h4>
                    <p>Enable AI-powered course generation</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="settings.aiCourseGeneration"
                    (change)="toggleChange('aiCourseGeneration')">
                </mat-slide-toggle>
            </div>
        </div>
        <div class="card">
            <h3>Notifications</h3>
            <p class="desc">Manage your notification preferences</p>

            <div class="toggle-row">
                <div>
                    <h4>Email Notifications</h4>
                    <p>Receive email updates about activity</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="settings.emailNotifications"
                    (change)="toggleChange('emailNotifications')">
                </mat-slide-toggle>
            </div>

            <div class="toggle-row">
                <div>
                    <h4>Weekly Reports</h4>
                    <p>Get weekly summary reports</p>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="settings.weeklyReports"
                    (change)="toggleChange('weeklyReports')">
                </mat-slide-toggle>
            </div>
        </div>
        <div class="card danger">
            <h3>Danger Zone</h3>
            <p class="desc">Irreversible actions for your account</p>

            <div class="danger-actions">
                <div class="danger-item">
                    <div>
                        <h4>Two-Factor Authentication</h4>
                        <p>Add an extra layer of security</p>
                    </div>
                    <button mat-stroked-button color="primary" (click)="enable2FA()">Enable 2FA</button>
                </div>

                <div class="danger-item">
                    <div>
                        <h4>Delete Account</h4>
                        <p>Permanently delete your account and all data</p>
                    </div>
                    <button mat-flat-button color="warn" (click)="deleteAccount()">Delete Account</button>
                </div>
            </div>
        </div>
    </div>
</div>